module.exports = __webpack_public_path__ + "static/media/smartBottle.cae8fb5f.webp";